import React, { Component, Fragment } from "react";
import { pricesUpdateAPI } from "../../../api";
import { connect } from "react-redux";

class ImportPricesForm extends Component {
  initialState = {
    mount: false,
    file: null,
  };
  state = this.initialState;

  componentDidMount() {}
  FileChange = (e) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (e) => {
      this.setState({ file: e.target.result });
    };
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.file) {
      const formData = {
        file: [this.state.file],
      };
      pricesUpdateAPI(formData).then((result) => {
        let informerClass = document.querySelector(".informer");
        if (result.response.success) {
          informerClass.classList.add("success", "animated", "zoomIn");
          informerClass.classList.remove("d-none");
          informerClass.innerHTML = result.response.success.msg;
          // console.log(result.response.success.items)
          setTimeout(() => {
            informerClass.classList.add("d-none");
            informerClass.classList.remove("success", "animated", "zoomIn");
          }, 10000);
          this.setState(this.initialState);
          document.querySelector(".btn-main").style.backgroundColor = "";
          document.querySelector(".btn-main").innerHTML = "Зберегти";
        }
        if (result.response.error) {
          informerClass.classList.add("error", "animated", "zoomIn");
          informerClass.classList.remove("d-none");
          informerClass.innerHTML = result.response.error.msg;
          setTimeout(() => {
            informerClass.classList.add("d-none");
            informerClass.classList.remove("success", "animated", "zoomIn");
          }, 10000);
        }
      });
    } else console.log("Помилка");
  };

  render() {
    const buttons = [{ func: this.FileChange, name: "file", id: "file-input" }];
    const ItemFileButton = buttons.map((item) => {
      return (
        <div className={"col-12"} id="upload-container" key={item.id}>
          <div>
            <input
              type="file"
              id={item.id}
              name={item.name}
              accept=".json,.jsn,application/json,text/json"
              onChange={item.func}
              className={"form-control file-control"}
            />
          </div>
        </div>
      );
    });

    return (
      <Fragment>
        <form
          onSubmit={this.handleSubmit}
          id="addForm"
          encType="multipart/form-data"
          method="POST"
        >
          <div className="form-group">
            <div className={"row"}>{ItemFileButton}</div>
            <button
              type="submit"
              className={"btn btn-main btn-lg btn-block"}
              onClick={(e) => {
                document.querySelector(".btn-main").style.backgroundColor =
                  "green";
                document.querySelector(".btn-main").innerHTML = "Відправляю...";
              }}
            >
              Зберегти
            </button>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default connect(null, null)(ImportPricesForm);
